export const fmtDate = (d: Date): string => {
  const day = d.getDate();
  const ord =
    day % 10 === 1 && day !== 11 ? 'st' :
      day % 10 === 2 && day !== 12 ? 'nd' :
        day % 10 === 3 && day !== 13 ? 'rd' : 'th';
  const month = d.toLocaleString('en-US', { month: 'long' });
  const time = d.toLocaleString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  return `${day}${ord} ${month}, ${time}`;
};

export const StatusWiseFooterText = {
    open: (props: any) => 'We’ll reach out to you in 24 hours',
    in_progress: (props: any) => 'Your issue will be resolved in 24 hours',
    resolved: (props: any) => `Resolved on ${fmtDate(new Date(props.updatedAt))}`,
    waiting_for_merchant: (props: any) => 'We have emailed you the details. Please respond so we can proceed.',
    cancelled: (props: any) => '',
};

export const getTicketStatusLabel = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'open':
      return 'Ticket Submitted';
    case 'in_progress':
      return 'In progress';
    case 'resolved':
      return 'Resolved';
    case 'waiting_for_merchant':
      return 'Input required';
    case 'cancelled':
      return 'Cancelled';
    default:
      return status?.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  }
};

